/* Cart quantities use native events so app-loaded jQuery cannot detach updates. */
(function () {
  'use strict';
  if (window.spCartQuantityInstalled) return;
  window.spCartQuantityInstalled = true;
  var busy = false;
  var inputSelector = '[data-cart-quantity-input]';
  function root() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }
  function lock(value) {
    document.querySelectorAll('[data-cart-form]').forEach(function (form) {
      form.setAttribute('aria-busy', String(value));
      form.querySelectorAll(inputSelector).forEach(function (input) { input.disabled = value; });
      form.querySelectorAll('.js-change-quantity').forEach(function (button) {
        button.classList.toggle('is-disabled', value);
      });
    });
  }
  function readJSON(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update quantity. Please try again.');
      return data;
    });
  }
  function refreshMiniCart(cart) {
    var form = document.querySelector('[data-cart-form="mini-cart"]');
    var section = form && form.closest('.shopify-section');
    if (!section) { window.location.reload(); return Promise.resolve(); }
    var url = root() + '?section_id=' + encodeURIComponent(section.id.replace('shopify-section-', ''));
    return fetch(url, {credentials:'same-origin',cache:'no-store'}).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh cart.');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var selectors = ['.js-cart_items','.js-cart_discounts','.js-cart_subtotal','.js-cart_savings'];
      if (!doc.querySelector('.js-cart_items')) throw new Error('Missing cart markup.');
      selectors.forEach(function (selector) {
        var source = doc.querySelector(selector);
        if (source) document.querySelectorAll('[data-cart-form="mini-cart"] ' + selector).forEach(function (target) {
          target.innerHTML = source.innerHTML;
        });
      });
      document.querySelectorAll('.cart_count').forEach(function (badge) { badge.textContent = String(cart.item_count); });
      document.querySelectorAll('.js-empty-cart__message').forEach(function (message) { message.classList.toggle('hidden', cart.item_count !== 0); });
      document.querySelectorAll('[data-cart-form="mini-cart"]').forEach(function (mini) { mini.classList.toggle('hidden', cart.item_count === 0); });
    }).catch(function () {
      // Shopify saved the update: reload rather than display stale totals.
      window.location.reload();
    });
  }
  function update(input, quantity) {
    var item = input.closest('[data-cart-item]');
    var form = input.closest('[data-cart-form]');
    if (!item || !form || busy) return;
    var previous = input.defaultValue;
    var payload = {quantity:quantity};
    if (item.dataset.lineKey) payload.id = item.dataset.lineKey;
    else payload.line = Number(item.dataset.lineId);
    if (!payload.id && !(payload.line > 0)) return;
    busy = true;
    input.value = String(quantity);
    item.querySelectorAll('.sp-cart-quantity-error').forEach(function (error) { error.remove(); });
    lock(true);
    fetch(root() + 'cart/change.js', {
      method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)
    }).then(readJSON).then(function (cart) {
      if (form.dataset.cartForm === 'cart-template') {
        window.location.reload();
        return;
      }
      return refreshMiniCart(cart);
    }).catch(function (error) {
      input.value = previous;
      var message = document.createElement('p');
      message.className = 'warning sp-cart-quantity-error';
      message.setAttribute('role','alert');
      message.textContent = error.message || 'Unable to update quantity. Please try again.';
      item.appendChild(message);
    }).then(function () { busy = false; lock(false); });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.js-change-quantity');
    if (!button) return;
    var box = button.closest('.product-quantity-box');
    var input = box && box.querySelector(inputSelector);
    if (!input) return; // Product-page purchase quantities keep Turbo behaviour.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    var current = Number(input.value);
    if (!Number.isInteger(current)) current = Number(input.defaultValue) || 0;
    var next = Math.max(0, current + (button.dataset.func === 'plus' ? 1 : -1));
    if (input.hasAttribute('max')) next = Math.min(next, Number(input.max));
    if (next !== current) update(input, next);
  }, true);
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches(inputSelector)) return;
    event.stopImmediatePropagation();
    var quantity = Number(input.value);
    if (busy || !Number.isInteger(quantity) || quantity < 0) { input.value = input.defaultValue; return; }
    update(input, quantity);
  }, true);
}());
